import { render, staticRenderFns } from "./BasketEn.vue?vue&type=template&id=0f8529b2&scoped=true&"
import script from "./BasketEn.vue?vue&type=script&setup=true&lang=js&"
export * from "./BasketEn.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8529b2",
  null
  
)

export default component.exports